/**
 * synchro-client にブラウザのログインを渡す（`synchro-client login --web`。Issue #877）の部品。画面は pages/CliLogin.js。
 */

/** `?port=&state=` → 渡す先（PC の中だけの口）。おかしければ null */
export function cliTarget(search) {
  const q = new URLSearchParams(search);
  const port = Number(q.get('port'));
  const state = q.get('state') || '';
  if (!Number.isInteger(port) || port < 1024 || port > 65535) return null;
  if (!/^[A-Za-z0-9_-]{16,128}$/.test(state)) return null;
  return { port, state, url: `http://127.0.0.1:${port}/callback` };
}

/** その口へフォームで POST する（ページはその口の返事に替わる） */
export function postToCli(target, fields, doc = document) {
  const form = doc.createElement('form');
  form.method = 'POST';
  form.action = target.url;
  for (const [name, value] of Object.entries(fields)) {
    const input = doc.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }
  doc.body.appendChild(form);
  form.submit();
}
